<template>
    <div class="univstudy__sidebar__filter margin--s-m">
        <h3 class="step--1 margin--s-m">{{ title }}</h3>
        <div 
            class="univstudy__filter" 
            :class="inputType" 
            v-for="(option, index) in visibleOptions" 
            :key="option.id"
        >
            <label class="paragraph--teaser" :class="option.count == 0 ? 'zero-count' : '' ">
                <div class="univstudy__filter__box__holder">
                    <input :type="inputType" :value="option.id" v-model="localValue" />
                    <span class="univstudy__filter__box"></span>
                </div>
                <p class="paragraph--teaser">
                    {{ getLocalizedName(option) }}
                    <span>
                        ({{ option.count }})
                    </span>
                </p>
            </label>
        </div>

        <button 
            v-if="options.length > 13" 
            @click="toggleShowAllOptions" 
            class="secondary-button download__button"
            :class="showAllOptions ? 'show-less' : 'show-more'">
                {{ showAllOptions ? printString('show_less') : printString('show_more') }}
                <span v-html="ico_down_16"/>
        </button>
    </div>
</template>


<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            default: () => [],
        },
        modelValue: {
            type: [Array, String, Number],
            required: true,
        },
        inputType: {
            type: String,
            validator: (value) => ["checkbox", "radio"].includes(value),
            default: "checkbox",
        },
    },
    data() {
        return {
            showAllOptions: false,  // Controls whether to show all options or just the first 12
            ico_down_16: window.ico_down_16,
            currentLang: window.lang || 'en', // Assuming window.lang is set to the current language
        };
    },
    computed: {
        // Local value management
        localValue: {
            get() {
                return this.inputType === "checkbox" ? [...this.modelValue] : this.modelValue;
            },
            set(value) {
                if (this.inputType === "checkbox") {
                    this.$emit("update:modelValue", value);
                } else {
                    this.$emit("update:modelValue", value);
                }
                this.$emit("applyFilters");
            },
        },
        // Conditionally return only the first 12 options or all based on showAllOptions
        visibleOptions() {
            return this.showAllOptions ? this.options : this.options.slice(0, 13);
        }
    },
    methods: {
        // Toggle method to switch between showing all or limited options
        toggleShowAllOptions() {
            this.showAllOptions = !this.showAllOptions;
        },

        getLocalizedName(option) {
            if (option.name && typeof option.name === 'object') {
                return option.name[this.currentLang] || option.name.en;
            }
            return option.name;
        },
        printString(string) {
            return window.translations[string];
        },
    }
};
</script>

